var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7612 10.9663L21.0322 1.23723C20.716 0.921033 20.2019 0.921033 19.8858 1.23723C19.5696 1.55342 19.5696 2.06744 19.8858 2.38364L28.2301 10.7279L1.81076 10.7279C1.36322 10.7279 1 11.0912 1 11.5387C1 11.9862 1.36322 12.3495 1.81076 12.3495L28.2301 12.3495L19.8858 20.6938C19.5696 21.0099 19.5696 21.524 19.8858 21.8402C20.0447 21.9991 20.2522 22.0769 20.4598 22.0769C20.6673 22.0769 20.8749 21.9974 21.0338 21.8402L30.7629 12.1111C31.079 11.7949 31.079 11.2809 30.7629 10.9647L30.7612 10.9663Z",
    fill: "#DDDBF1",
    stroke: "#DDDBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.4621380bd1a1585da6a7537fc8b2f9a9.svg";
export { ForwardRef as ReactComponent };